<template>
    <div class="bodyAssinatura">
        <b-modal ref="add-novo-orientacao"
        size="md"
        centered
        title="Adicionar Orientações"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        body-class="rounded-bottom-1rem "
        content-class="rounded-1rem"
        @shown="focarDescricao"
        >
        <template #modal-title>
            <div class="header-title">{{Editar === false ? 'Adicionar orientações' : 'Editar  orientações'}}</div>
        </template>
            <div class="container-new-template">
                <!-- <div class="search-container"  v-if="cadastros === false">
                    <i class="fas fa-search icone-search"></i>
                    <input v-model="buscaItem" class="input-pesquisar" placeholder="Pesquisar Item"/>
                </div> -->
                <!-- <p class="sublinhado" @click="ItemNovoParaLita" v-if="cadastros === false">Adicionar novo item a lista</p> -->

                <!-- <div class="container-add-itens"  v-if="cadastros === true"> -->
                  <input type="file" id="impor-Img" itemid="impor-Img"  accept="image/png, image/jpeg" v-on:change="GetValueFile">

                  <label v-if="Editar === false" class="labelsearch margem">Descrição
                   <span style="color: #540000; font-weight: bold;" v-b-tooltip.hover title="Item obrigatório"> *</span>
                  </label>
                  <b-form-textarea v-if="Editar === false" ref="descricaoTextarea" class="input-descricao" rows="3" v-model="novoItemDescricao"  placeholder="Descrição Item"></b-form-textarea>

                  <b-form-group
                  class="font pivs"
                  style="margin-bottom: 1rem;"
                  id="Input-group-template-pes"
                  label="Nível Prioridade"
                  label-for="input-template-pes"
                >
                  <b-form-input
                    class="input"
                    id="input-new-pes"
                    name="input-new-pes"
                    type="text"
                    v-model="nivelPrioridade"
                    v-mask="'######'"
                    v-validate="{ alpha_spaces: true, required: true }"
                    placeholder="Dígite o nível de prioridade"
                  ></b-form-input>
                </b-form-group>

                  <div class="d-flex w-100" v-if="Editar === false">
                    <label class="labelsearch margem mt-2">Imagem</label>

                    <div class="container-icone-edicao d-flex">
                      <div class="icone-button" v-b-tooltip.hover :title="'Editar Imagem'" v-if="file64 !== null" v-on:click="openFileImg">
                        <i class="fas fa-pen"></i>
                      </div>
                      <div class="icone-button" v-b-tooltip.hover :title="'Excluir Imagem'" v-if="file64 !== null" @click="removerOpcoesImagem">
                        <i class="fas fa-trash"></i>
                      </div>
                    </div>
                  </div>

                  <div class="container-img" v-if="Editar === false">
                    <div style="display: flex; align-items: center;" class="img-body-uplaod" v-on:click="openFileImg" v-if="file64 === null">
                        <div class="img-body-info"  >
                          <i class="fas fa-cloud-upload-alt" style="font-size: 35px"></i>
                          <div  class="mt-3" style="font-size: 14px; text-align: center;" >FAÇA O UPLOAD</div>
                          <div style="font-size: 12px; text-align: center;" >Escolha a imagem</div>
                        </div>
                    </div>
                    <div class="container-img-base" v-if="file64 !== null">
                      <div class="card-img-pergunta-pre-viualizacao card-img-pergunta-border card-img-pergunta-pre-visualizacao">
                        <img :src="file64" class="img-galeria  altura-img card-img-pergunta-pre-visualizacao"/>
                        <div class="comprovante-footer">{{ nameFile }}</div>
                      </div>
                    </div>
                  </div>
                <!-- </div> -->

                <!-- <div class="container-add-itens" v-if="cadastros === false">
                  <div v-for="data in dataFiltroQMAOrientacao" v-bind:key="data.id" >
                    <div class="itens">
                      <div class="nome-itens">
                        {{ data.descricao }}
                      </div>
                      <div class="button-epi-selecionado">
                          <div class="button" :id="data.id" @click="AdicionarIten(data)"><i class="fas fa-plus icone-add"></i></div>
                      </div>
                    </div>
                    <div class="container-icon-img" v-if="data.imagem === true">
                      <img v-if="data.id !== perguntaId" class="img_tipo_campo" style="margin-left: 0.5rem"  :src="iconImg" v-b-tooltip.hover :title="'Abrir imagem'" @click="downloadOrientacaoImagem(data.urlImagem, data.id)">
                      <i v-if="data.id === perguntaId && file64 !== null" style="margin-left: 1rem; font-size: 16px" class="fas fa-times" v-b-tooltip.hover :title="'Fechar Imagem'" @click="fechaImg()"></i>
                    </div>

                    <div
                      class="img-preview"
                      :class="{ show: file64 !== null && data.id === perguntaId }"
                      v-if="data.imagem === true && data.id === perguntaId"
                    >
                      <img style="border-radius: 10px;" :src="'data:image/jpeg;base64,' + file64" />
                    </div>

                  </div>
                </div> -->
                <div class="d-flex container_cancel_save">
                    <div class="cancelar">
                        <button class="button-cancel" @click="fecharPopUptAdd">CANCELAR</button>
                    </div>
                    <div class="criar">
                        <button class="button-save" v-if="Editar === false" @click="validaCampos">CADASTRAR</button>
                        <button class="button-save" v-if="Editar === true" @click="editarOrientacao">EDITAR</button>

                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import newGuidance from './newGuidance'
export default newGuidance
</script>

    <style scoped>
    .img-preview {
      opacity: 0;
      transition: opacity 0.5s ease-in-out; /* Duração de 0.5s para a transição */
      display: none; /* Esconde o elemento inicialmente */
      justify-content: center;
      margin: 1rem;
      background: #efefef;
      border-radius: 7px;
      padding: 1rem;
    }

    .img-preview.show {
      opacity: 1;
      display: flex; /* Flexbox é ativado apenas quando a classe "show" é aplicada */
      justify-content: center;
      margin: 1rem;
      background: #efefef;
      border-radius: 7px;
      padding: 1rem;
    }

    .container-icon-img {
      margin: 0.5rem 0 0.5rem 0;
    }
    .img_tipo_campo {
      width: 28px;
    }
    .container-icone-edicao {
      width: 100%;
      gap: 1rem;
      justify-content: end;
    }

    .img-galeria {
      object-fit: cover;
      border-radius: 10px;
      overflow: hidden;
      width: 100%;
    }
    #impor-Img {
      display: none;
    }
    .comprovante-footer{
        width: 100%;
        font: normal normal 600 11px / 24px Segoe UI;
        white-space: pre-wrap;
        word-break: break-all;
        height: fit-content;
        line-height: 14px;
        padding: 5px;
        position: absolute;
        font-weight: bold;
        background: rgb(173 173 173);
        bottom: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: rgb(255, 255, 255);
        border-radius: 0px 0px 10px 10px;
    }
    .card-img-pergunta-pre-viualizacao {
      height: 10rem;
      font-size: 25px;
      color: grey;
      border-radius: 10px;
      position: relative;
      margin-bottom: 15px;
      display: flex;
      position: relative;
      -ms-flex-align: center;
      cursor: pointer;
      -webkit-transition: .5s;
      transition: .5s;
    }
    .card-img-pergunta-pre-visualizacao {
      width: 9rem;
    }
    .container-img-base {
      width: fit-content;
      display: flex;
      gap: 0.5rem;
    }
    .container-img {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .img-body-uplaod{
      width: 40%;
      height: 9rem;
      font-size: 25px;
      color: grey;
      border-radius: 10px;
      position: relative;
      flex-direction: column;
      margin-bottom: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border: 2px dotted #bebebe;
      transition: .5s;
    }

    .icone-button {
      cursor: pointer;
      border: 1px solid #008148;
      color: #008148;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 28px;
      font-size: 11px;
    }

    .img-body-info{
      width: 100%;
      display: flex;
      height: 100%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .container_img {
      display: flex;
      justify-content: center;
      width: 100%;
    }
    .img_tipo_cadastro {
      margin: 2rem 0 1rem 0;
      width: 13%;
    }
    .img_semDados {
      display: flex;
      justify-content: center;
      width: 100%;
    }
    .sublinhado {
      width: 100%;
      font: normal normal 600 13px/21px Segoe UI;
      text-align: center;
      color: #008144;
      text-decoration: underline;
      margin-bottom: 1rem;
    }
    .img_tipo_campo {
      width: 28px;
      padding-left: 0.5rem
    }
    .header-title{
      color: white;
      font-weight: bold;
      font-size: 16px;
      font-family: 'Segoe UI';
    }
    .bodyCabecalho{
      width: 100%;
    }
    .nome-itens{
      gap: 1rem;
      color: #747474;
      font-size: 13px;
      font-family: 'Segoe UI';
      width: 100%;
      display: flex;
      align-items: center;
    }
    .container-add-itens{
      width: 100%;
      height: fit-content;
      padding: 0 5px 0 5px;
      border-bottom: 1px solid rgb(233, 233, 233);
      height: 15rem;
      overflow: auto;
      border-bottom: 1px solid #D4D4D4;
      border-radius: 10px;
    }
    .container-add-itens::-webkit-scrollbar-track {
      background-color: #F4F4F4;
      border-radius: 10px;
    }
    .container-add-itens::-webkit-scrollbar {
        width: 6px;
        background: #F4F4F4;
        border-radius: 10px;
    }
    .container-add-itens::-webkit-scrollbar-thumb {
        background: #dad7d7;
        border-radius: 10px;
    }
    .itens {
      border-top: 1px solid  rgb(233, 233, 233);
      padding: 0.5rem;
      width: 100%;
      display: flex;
      width: 100%;
    }
    .button-epi-selecionado{
      display: flex;
      align-items: center;
      width: 10%;
      justify-content: end;
    }
    .button{
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgb(216, 216, 216);
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 50%;
    }
    .button.clicked {
          background-color: #008144; /* Cor de fundo alterada */
     }
    .icone-add {
      color: white;
      font-size: 11px;
    }
   .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 20px;
   }
   .button-cancel{
     background-color: #b60000;
     color: white;
   }
   .button-save{
    background-color: darkgreen;
    color: white;
   }

  .button-cancel,
  .button-save{
    margin-top: 10;
    font-size: 12PX;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
  .input-pesquisar{
      width: 100%;
      margin-top: 0.5rem;
      height: 2rem;
      border: 1px solid rgb(216, 216, 216);
      border-radius: 2px;
      padding-left: 2rem;
      margin-bottom: 1rem;
  }
  .input-descricao{
      width: 100%;
      margin-top: 0.5rem;
      border: 1px solid rgb(216, 216, 216);
      border-radius: 2px;
      padding-left: 17px;
      margin-bottom: 1rem;
  }
  .icone-search{
      position: absolute;
      left: 10px;
      top: 18px;
      font-size: 14px;
  }
  .search-container {
    position: relative;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/newGuidance/newGuidance.vue